const layout = [
  'Q#############E',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'TBBBBBBBBBBBBBY',
];

export const empty = layout.join('\n');
